import { Texture } from "@/core/backends/webgl/texture"
import { RenderPass } from "@/core/pipeline/render-pass"
import { OutputColorSpace, RenderColorSpace } from "@/core/types"

export interface RGBPlaneOutput {
	r: Texture
	g: Texture
	b: Texture
}

export class RGBPlaneOutputPass extends RenderPass {
	render(
		input: Texture,
		output: RGBPlaneOutput,
		options?: {
			outputColorSpace?: RenderColorSpace
		},
	) {
		let outputColorSpace: OutputColorSpace

		switch (options?.outputColorSpace) {
			case "srgb":
				outputColorSpace = OutputColorSpace.sRGB
				break
			case "gamma":
				outputColorSpace = OutputColorSpace.gamma
				break
			default:
				outputColorSpace = OutputColorSpace.displayP3
				break
		}

		this.renderChannel(input, output.r, 0, outputColorSpace)
		this.renderChannel(input, output.g, 1, outputColorSpace)
		this.renderChannel(input, output.b, 2, outputColorSpace)
	}

	private renderChannel(
		input: Texture,
		output: Texture,
		channel: number,
		outputColorSpace: OutputColorSpace,
	) {
		const { renderer } = this

		renderer.setRenderTarget(output)
		input.bind(0)
		renderer.alphaTexture.bind(1)
		renderer.shaders.rgbPlaneOutput.render({
			inputTexture: 0,
			alphaTexture: 1,
			outputColorSpace,
			channel,
		})
	}

	dispose() {
		return
	}
}
